import __request__ from "routing/request";
export function list(sort = "title", page = 1, per_page = 15, query, order = "asc", state = "any", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order, "state": state }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByIds(forwarder_ids, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/byIds", forwarder_ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByNodeId(forwarderId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/byNodeId/${forwarderId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfiguration(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function pendingConfiguration(sort = "created_at", page = 1, per_page = 0, query, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/pending_configuration", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBasicForwarderUser(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/user", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(forwarderId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/${forwarderId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(forwarderId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/${forwarderId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(forwarderId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.forwarder/forwarder/forwarders/${forwarderId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
